export default __webpack_public_path__ + "static/media/obj1.95ed3b3a.svg";